import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const AutomaticPaymentRemindersPage = lazyImport(
  () => import('~/views/outstanding-automatic-payment-reminders/AutomaticPaymentRemindersPage'),
);

export const outstandingAutomaticPaymentRemindersRoutes: RouteObject[] = [
  {
    index: true,
    element: <AutomaticPaymentRemindersPage />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Outstanding.buildLink()} replace />,
  },
];
